export const clearAppData = async () => {
  try {
    // cookies
    const theCookies = document.cookie.split(';');
    for (var i = 1; i <= theCookies.length; i++) {
      const acookie = theCookies[i - 1];
      const cookieArr = acookie.split('=');
      document.cookie = cookieArr[0] + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }

    // Get cache storage and clear cache storage
    await window.caches.keys().then(function (names) {
      for (let name of names) window.caches.delete(name);
    });

    // clear localStorage
    const accessToken = window.localStorage.getItem('accessToken');
    const refreshToken = window.localStorage.getItem('refreshToken');
    const clientId = window.localStorage.getItem('clientId');
    window.localStorage.clear();
    if (accessToken && refreshToken && clientId) {
      window.localStorage.setItem('accessToken', accessToken);
      window.localStorage.setItem('refreshToken', refreshToken);
      window.localStorage.setItem('clientId', clientId);
    }

    // clear sessionStorage
    window.sessionStorage.clear();

    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(reg => reg.unregister()));
  } catch (err) {
    console.error('Error clearing app data:', err);
  }
};
